

import { useEffect, useRef, useState } from 'react'
import Loader from '../../components/loader';
import Layout from '../../components/Layout';
import api from '../../utils/api';
import { errorMessage } from '../../utils/utils';
import Spinner from '../../components/spinner';
import ReactCountryFlag from 'react-country-flag';
import moment from 'moment';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { FaExclamation, FaQuestion } from 'react-icons/fa';
import { ErrorState } from '../../components/ui';
import { ListLoading } from '../../components/ListToolbar';
import { CreditsPayment, useCredits } from '../../components/Credits';

const monthly = 40;
const yearly = 360;

export default function RemoteNew() {

    useEffect(() => {

        if (!window.localStorage.token) {
            window.location.replace('/signin');
            return;
        }

        setPageLoading(false);

        getServers();

    }, []);

    const [pageLoading, setPageLoading] = useState(true);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [errorService, setErrorService] = useState(false);
    const [errorSubsPlan, setErrorSubsPlan] = useState(false);
    const [errorPort, setErrorPort] = useState(false);
    const [errorCustom, setErrorCustom] = useState(false);
    const [errorProtocol, setErrorProtocol] = useState(false);
    const [errorLabel, setErrorLabel] = useState(false);

    const [serverLoading, setServerLoading] = useState(true);
    const [serverError, setServerError] = useState('');
    const [serverData, setServerData] = useState<any>();

    const [servers, setServers] = useState<any[]>([]);
    const [services, setServices] = useState<any[]>([]);

    const [server, setServer] = useState('');
    const [quantity, setQuantity] = useState('1');

    const [unit, setUnit] = useState('');
    const [service, setService] = useState('');

    const [app_port, setAppPort] = useState('');
    const [custom, setCustom] = useState('');
    const [protocol, setProtocol] = useState('');

    const [label, setLabel] = useState('');

    const [expiration, setExpiration] = useState<any>();

    const [confirmDialog, setConfirmDialog] = useState(false);
    const [purchaseError, setPurchaseError] = useState('');
    const [free, setFree] = useState<any>(false);

    const { balance, error: balanceError } = useCredits();

    if (pageLoading) {
        return (<div className='w-screen h-screen text-center flex flex-col bg-white justify-center'><Loader /></div>)
    }

    async function getServers() {
        try {
            const res = await api.get(`/remote/server`);
            const json = await res.json();
            if (res.ok) {
                setServers(json);

                // Default to the Philippines server; fall back to whatever is enabled.
                var find = json.find((item: any) => item.enabled && item.location?.toUpperCase() === 'PH')
                    ?? json.find((item: any) => item.enabled)
                    ?? json[0];

                if (find) {
                    setServer(find.name);
                    setServices(find.services);
                    setUnit('year');
                    // Prefer ovpn, but only if this server actually offers it.
                    setService(find.services?.includes('ovpn') ? 'ovpn' : find.services?.[0] ?? '');
                    getExpirationDate('1', 'yearly');
                    setAppPort('8291');
                    setServerData(find);
                }
            } else {
                setServerError(errorMessage(json));
            }
        } catch (err) {
            setServerError(errorMessage(err));
        }

        setServerLoading(false);
    }

    function getExpirationDate(quantity: string, unit: string) {
        var now = new Date();
        const exp = new Date(now);

        switch (unit) {
            case 'month':
                exp.setMonth(now.getMonth() + parseInt(quantity));
                break;
            case 'year':
                exp.setFullYear(now.getFullYear() + parseInt(quantity));
                break;
        }

        setExpiration(moment(exp).format('MMMM Do YYYY'));
    }

    function price() {
        const qty = parseInt(quantity);
        return (unit === 'year' ? yearly : monthly) * (isNaN(qty) ? 0 : qty);
    }

    function submit(free?: boolean) {
        
        if ((!quantity || !unit)) {
            setErrorSubsPlan(true);
            setError('Please select subscription plan');
            return scrollToSection('plan');
        } else {
            setErrorSubsPlan(false);
        }

        if (!service) {
            setErrorService(true);
            setError('Please select a service');
            return scrollToSection('service');
        } else {
            setErrorService(false);
        }

        if (!app_port) {
            setErrorPort(true);
            setError('Please select a port');
            return;
        } else {
            setErrorPort(false);
        }

        if (app_port === 'custom') {
            let missing = false;

            if (!custom) {
                setErrorCustom(true);
                missing = true;
            } else {
                setErrorCustom(false);
            }

            if (!protocol) {
                setErrorProtocol(true);
                missing = true;
            } else {
                setErrorProtocol(false);
            }

            if (missing) {
                setError('Please select a port or protocol in custom port');
                return;
            }

        } else {
            setErrorCustom(false);
            setErrorProtocol(false);
        }


        if (!label) {
            setErrorLabel(true);
            setError('Please enter a label');
            return  scrollToSection('label');
        } else {
            setErrorLabel(false);
        }


        if (!free && (balance === undefined || balance < price())) {
            setError('You do not have enough credits for this plan. Please top up your credits first.');
            return  scrollToSection('payment');
        }


        setError('');
        setPurchaseError('');
        setFree(free);
        setConfirmDialog(true);
    }

    async function purchase() {
        setLoading(true);
        try {

            const res = await api.post(`/remote`, { server, quantity, unit, service, app_port, custom, protocol, label, free, });
            const json = await res.json();

            if (res.ok) {
                window.location.replace('/remote');
                return;
            } else {
                setPurchaseError(errorMessage(json));
            }

        } catch (error) {
            setPurchaseError(errorMessage(error));
        }

        setLoading(false);

    }

    function isFree() {

        if (server) {
            const find = servers.find((item: any) => item.name === server);
            if (find) {
                if (find.free?.length > 0) {
                    const qty = parseInt(quantity.toString());
                    const free = find.free.find((item: any) => item.unit === unit && item.quantity >= qty);
                    if (free) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    return (
        <>
            <Layout
                nav='remote'
                title={`My Remote Accounts > New`}
                footer={server && (
                    <div className='px-4 py-4'>

                        {error && <div className='mb-2 text-center text-red-500 italic text-xs' dangerouslySetInnerHTML={{ __html: error }} ></div>}

                        <div className='flex flex-row items-center gap-2'>

                            <button type="button" className='inline-flex min-h-[40px] items-center rounded-xl bg-white px-4 text-sm font-semibold text-slate-700 ring-1 ring-inset ring-slate-200 transition hover:bg-slate-50'
                                onClick={() => window.history.back()}
                            >Back</button>

                            <span className='grow'></span>

                            <div className='flex flex-row items-center gap-x-2'>
                                <button
                                    disabled={loading || !server || !isFree()}
                                    onClick={() => submit(true)}
                                    className='inline-flex min-h-[40px] items-center rounded-xl bg-gradient-to-b from-emerald-500 to-emerald-600 px-4 text-sm font-bold text-white shadow-lg shadow-emerald-600/25 transition hover:from-emerald-600 hover:to-emerald-700 disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:shadow-none'>Get Free</button>
                                <button
                                    disabled={loading || !server}
                                    onClick={() => submit()}
                                    className='inline-flex min-h-[40px] items-center rounded-xl bg-gradient-to-b from-emerald-500 to-emerald-600 px-4 text-sm font-bold text-white shadow-lg shadow-emerald-600/25 transition hover:from-emerald-600 hover:to-emerald-700 disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:shadow-none'>Buy Now</button>
                            </div>

                        </div>

                    </div>
                )}>

                    <div className="mx-auto max-w-6xl px-5 py-8 sm:px-8">

                        <button
                            type="button"
                            onClick={() => window.history.back()}
                            className="inline-flex items-center gap-1 text-sm font-semibold text-slate-400 transition hover:text-slate-950">
                            <svg viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4">
                                <path fillRule="evenodd" d="M17 10a.75.75 0 0 1-.75.75H5.612l4.158 3.96a.75.75 0 1 1-1.04 1.08l-5.5-5.25a.75.75 0 0 1 0-1.08l5.5-5.25a.75.75 0 1 1 1.04 1.08L5.612 9.25H16.25A.75.75 0 0 1 17 10Z" clipRule="evenodd" />
                            </svg>
                            Go back
                        </button>

                        <h1 className="mt-4 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">New Remote</h1>
                        <p className="mt-1 text-sm text-slate-500">Configure your remote access account and complete the purchase.</p>

                        {serverLoading && <ListLoading label='Loading servers...' />}
                        {(!serverLoading && serverError) && <ErrorState error={serverError} />}

                        <div className={`mt-8 grid gap-8 lg:grid-cols-[1fr_380px] ${(serverLoading || serverError) && 'hidden'}`}>
                            <div className='space-y-8'>
                                <section className='rounded-2xl border border-slate-200 bg-white p-5 sm:p-6'>
                                    <div>
                                        <h2 className='text-sm font-bold uppercase tracking-wider text-slate-400'>1. Remote Server</h2>
                                        <ul className='mt-4 flex flex-col gap-3 sm:ml-2'>
                                            {servers?.map((item: any, index: number) => {
                                                return <li
                                                    key={`${index}-server`}
                                                    className={`flex flex-row items-center gap-3 w-full sm:w-[320px] py-3 rounded-xl px-3.5 ring-1 transition-all hover:shadow-md ${item.name === server ? 'ring-2 ring-blue-500 bg-blue-50/50 shadow-md' : 'ring-slate-200 bg-white'} ${item.enabled && 'cursor-pointer'}`}
                                                    onClick={item.enabled ? () => {
                                                        if (item.name === server) {
                                                            setServer('');
                                                            setUnit('');
                                                            setService('');
                                                            setServices([]);
                                                            setAppPort('');
                                                            setCustom('');
                                                            setProtocol('');
                                                            setQuantity('');
                                                            setExpiration('');
                                                            setServerData(null);
                                                        } else {
                                                            setServer(item.name);
                                                            setServices(item.services);
                                                            setService('ovpn');
                                                            setUnit('year');
                                                            setQuantity('1');

                                                            // if (item.subscription === 'paid') {
                                                                
                                                            // } else {
                                                            //     setQuantity('1');
                                                            //     setUnit('month');
                                                            //     setPayment('');
                                                            //     setErrorPayment(false);
                                                            // }

                                                            const find = servers.find((value: any) => value.name === item.name);
                                                            setServerData(find);
                                                            getExpirationDate('1', 'year');
                                                        }
                                                    } : undefined}>

                                                    <div className='group relative flex justify-center'>
                                                        <ReactCountryFlag
                                                            countryCode={item?.location}
                                                            svg
                                                            style={{ width: '40px', height: '30px', }}
                                                            className={`ring-1 ring-slate-200 rounded-sm ${!item.enabled && 'grayscale'}`}
                                                        />
                                                        <span className="absolute z-10 top-10 scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100">{item?.location?.toUpperCase()}</span>
                                                    </div>

                                                    <div className={`flex flex-col ${!item.enabled && 'text-gray-400'}`}>
                                                        <div className={`leading-none text-sm font-medium`}>{item.label}</div>
                                                        <div className={`flex flex-row items-center gap-1 mt-[2px] ${item.enabled && 'hidden'}`}>
                                                            <div className='text-[11px]'>(unavailable)</div>
                                                        </div>
                                                    </div>

                                                </li>

                                            })}
                                        </ul>
                                    </div>

                                    </section>

                                    <section className={`rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 transition ${!server ? 'opacity-50' : ''}`}>
                                    <div id="plan">
                                        <h2 className='text-sm font-bold uppercase tracking-wider text-slate-400'>2. Subscription Plan</h2>
                                        <div className={`text-xs text-red-500 font-medium ${!errorSubsPlan && 'hidden'}`}>* Please select subscription plan</div>
                                        {(serverData && serverData?.free?.length > 0) && <div className='flex flex-col text-xs sm:ml-2'>{serverData?.free?.map((item: any, index: number)=>{
                                            return <div key={`${index}-free`} className='text-green-500 italic'>Free up to {item.quantity} {item.unit}</div>
                                        })}</div>}
                                        <div className='ml-5 mt-3 flex flex-row items-center gap-3'>
                                            <input
                                                type="number"
                                                min={1}
                                                value={quantity}
                                                style={{ width: "100px", height: '40px' }}
                                                disabled={loading}
                                                aria-describedby="helper-text-explanation"
                                                className="min-h-[40px] rounded-xl border-0 bg-white px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50"
                                                // placeholder="1"
                                                onChange={(e) => {
                                                    if (e.target.value === '0') return;
                                                    setQuantity(e.target.value);
                                                    getExpirationDate(e.target.value, unit);
                                                    if (unit) {
                                                        setErrorSubsPlan(false);
                                                    }
                                                }}
                                            />
                                            <select
                                                value={unit}
                                                style={{ width: "150px", height: '40px' }}
                                                disabled={loading}
                                                className={`min-h-[40px] rounded-xl border-0 bg-white px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50`}
                                                onChange={(e) => {
                                                    setUnit(e.target.value);
                                                    getExpirationDate(quantity, e.target.value);
                                                    if (quantity) {
                                                        setErrorSubsPlan(false);
                                                    }
                                                }}>
                                                <option disabled={true}>Please select...</option>
                                                <option value='month'>Month{parseInt(quantity) > 1 ? 's' : ''}</option>
                                                <option value='year'>Year{parseInt(quantity) > 1 ? 's' : ''}</option>
                                            </select>
                                        </div>
                                        <div className='ml-5 mt-2 flex flex-row items-center gap-2'>
                                            <div className='text-xs'>Estimated date expiration:</div>
                                            <div className='text-xs font-medium'>{expiration}</div>
                                        </div>
                                    </div>

                                    <div id='service' className={`${services.length === 0 && 'hidden'}`}>
                                        <hr className='my-6 border-slate-100' />
                                        <h2 className='text-sm font-bold uppercase tracking-wider text-slate-400'>3. Service</h2>
                                        <div className={`text-xs text-red-500 font-medium ${!errorService && 'hidden'}`}>* Please select a service</div>
                                        {/* <div className='ml-5 text-xs'>Services may vary depending on the supported devices.</div> */}
                                        <ul className='ml-5 mt-3 mb-5 flex flex-row items-center gap-3'>

                                            {services.map((item: any, index: number) => {
                                                return <li key={`${index}-service`} className={`flex min-h-[42px] w-[92px] cursor-pointer items-center justify-center rounded-xl text-sm font-semibold uppercase ring-1 transition-all hover:shadow-md ${item === service ? 'bg-blue-600 text-white ring-blue-600 shadow-md shadow-blue-600/25' : 'bg-white text-slate-600 ring-slate-200'}`}
                                                    onClick={() => {
                                                        if (item === service) {
                                                            setService('');
                                                            setAppPort('');
                                                            setCustom('');
                                                            setProtocol('');
                                                        } else {
                                                            setService(item);
                                                            setAppPort('');
                                                            setErrorService(false);
                                                        }
                                                    }}
                                                >
                                                    {item.toUpperCase()}
                                                </li>
                                            })}
                                        </ul>


                                    </div>

                                    <div className={`${!service && 'hidden'}`}>
                                        <hr className='my-6 border-slate-100' />
                                        <h2 className='text-sm font-bold uppercase tracking-wider text-slate-400'>4. Port</h2>
                                        <div className='ml-5 text-xs lg:mr-10'>The port you want to remote. (e.g. if you want to remote from winbox use 8291, if you want to remote adopisoft use 443)</div>
                                        <div className='ml-5 mt-3'>
                                            <select
                                                value={app_port}
                                                style={{ width: "250px", height: '40px' }}
                                                disabled={loading}
                                                className={`min-h-[40px] rounded-xl border-0 bg-white px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50`}
                                                onChange={(e) => {
                                                    setAppPort(e.target.value);

                                                    if (e.target.value !== 'custom') {
                                                        setCustom('');
                                                        setProtocol('');
                                                    }

                                                    if (e.target.value) {
                                                        setErrorPort(false);
                                                    }

                                                }}>
                                                <option value=''>Select...</option>
                                                <option value='8291'>Winbox (8291)</option>
                                                <option value='443'>HTTPS (443)</option>
                                                <option value='80'>HTTP (80)</option>
                                                <option value='custom'>Others</option>
                                            </select>
                                            <div className={`text-xs font-medium text-red-500 ${!errorPort && 'hidden'}`}>* Please select a port</div>
                                        </div>
                                        <div className={`ml-5 mt-3 flex flex-row gap-3 ${app_port !== 'custom' && 'hidden'}`}>
                                            <div className="mb-2 flex flex-col">
                                                <label htmlFor="custom" className="block text-sm font-medium leading-6 text-gray-900">Port</label>
                                                <div className='grow'>
                                                    <input
                                                        type="text"
                                                        // required={app_port === 'custom' ? true : false}
                                                        value={custom}
                                                        disabled={loading}
                                                        maxLength={5}
                                                        style={{ width: "118px", height: '40px' }}
                                                        placeholder="0 to 65535"
                                                        className="block w-full min-h-[40px] rounded-xl border-0 bg-white px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50 py-2 placeholder:text-sm placeholder:text-slate-400"
                                                        onChange={(e) => {
                                                            const re = /^[0-9\b]+$/;
                                                            if (e.target.value === '' || re.test(e.target.value)) {
                                                                setCustom(e.target.value);

                                                                if (e.target.value) {
                                                                    setErrorCustom(false);
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <div className={`text-xs font-medium text-red-500 w-[118px] ${!errorCustom && 'hidden'}`}>* Enter a port</div>
                                                </div>
                                            </div>

                                            <div className="mb-2 flex flex-col">
                                                <label htmlFor="protocol" className="block text-sm font-medium leading-6 text-gray-900">Protocol</label>
                                                <select
                                                    // required={app_port === 'custom' ? true : false}
                                                    value={protocol}
                                                    disabled={loading}
                                                    style={{ width: "118px", height: '40px' }}
                                                    className={`min-h-[40px] rounded-xl border-0 bg-white px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50`}
                                                    onChange={(e) => {
                                                        setProtocol(e.target.value);
                                                        if (e.target.value) {
                                                            setErrorProtocol(false);
                                                        }
                                                    }}>
                                                    <option value=''>Select...</option>
                                                    <option value='tcp'>TCP</option>
                                                    <option value='udp'>UDP</option>
                                                </select>
                                                <div className={`text-xs font-medium text-red-500 ${!errorProtocol && 'hidden'}`}>* Enter a protocol</div>
                                            </div>
                                        </div>

                                    </div>

                                    </section>

                                    <section className='rounded-2xl border border-slate-200 bg-white p-5 sm:p-6'>
                                    <div id='label' className={`lg:mb-5 ${!app_port && 'hidden'}`}>
                                        <h2 className='text-sm font-bold uppercase tracking-wider text-slate-400'>5. Details</h2>
                                        <div className={`text-xs font-medium text-red-500 ${!errorLabel && 'hidden'}`}>* Please enter a label</div>
                                        <div className='ml-5 mt-3'>
                                            <input
                                                type="text"
                                                value={label}
                                                disabled={loading}
                                                style={{ width: "285px" }}
                                                placeholder="e.g. Mikrotik hEX"
                                                className="block w-full min-h-[40px] rounded-xl border-0 bg-white px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50 py-2 placeholder:text-sm placeholder:text-slate-400"
                                                onChange={(e) => {
                                                    setLabel(e.target.value);
                                                    if (e.target.value) {
                                                        setErrorLabel(false);
                                                    }
                                                }}
                                            />
                                        </div>

                                    </div>
                                </section>
                            </div>

                            <div className='lg:sticky lg:top-24 lg:self-start'>
                              <div className={`space-y-5 ${!server && 'opacity-50'}`}>

                                <div className='rounded-2xl border border-slate-200 bg-white p-5 sm:p-6'>

                                    <h2 className='mb-4 text-sm font-bold uppercase tracking-wider text-slate-400'>Purchase Summary</h2>

                                    <div className='flex items-start justify-between gap-4 py-1.5 text-sm'>
                                        <span className='text-slate-500'>Server:</span><span className='text-right font-semibold text-slate-800'>{servers.find((item: any) => item.name === server)?.label}</span>
                                    </div>

                                    <div className='flex items-start justify-between gap-4 py-1.5 text-sm'>
                                        <span className='text-slate-500'>Plan:</span><span className='text-right font-semibold text-slate-800'>{quantity} {unit}{`${parseInt(quantity) > 1 ? 's' : ''}`}</span>
                                    </div>

                                    <div className='flex items-start justify-between gap-4 py-1.5 text-sm'>
                                        <span className='text-slate-500'>Expiration:</span><span className='text-right font-semibold text-slate-800'>{expiration}</span>
                                    </div>

                                    <div className='flex items-start justify-between gap-4 py-1.5 text-sm'>
                                        <span className='text-slate-500'>Service:</span><span className='text-right font-semibold text-slate-800'>{service}</span>
                                    </div>

                                    <div className='flex items-start justify-between gap-4 py-1.5 text-sm'>
                                        <span className='text-slate-500'>To Port:</span><span className='text-right font-semibold text-slate-800'>{app_port === 'custom' ? custom ? `${protocol}${protocol ? ':' : ''}${custom}` : '' : app_port}</span>
                                    </div>

                                    <div className='flex items-start justify-between gap-4 py-1.5 text-sm'>
                                        <span className='text-slate-500'>Label:</span><span className='text-right font-semibold text-slate-800'>{label}</span>
                                    </div>

                                </div>

                                <div id='payment' className='rounded-2xl border border-slate-200 bg-white p-5 sm:p-6'>

                                    <h2 className='mb-4 text-sm font-bold uppercase tracking-wider text-slate-400'>Pay with Credits</h2>

                                    <CreditsPayment price={price()} balance={balance} error={balanceError} />

                                    <div className='mt-3 text-xs'>A confirmation receipt will be sent to <span className='font-bold'>{window.localStorage['email']}</span></div>

                                </div>

                              </div>
                            </div>

                        </div>

                    </div>

            </Layout>

            <ConfirmDialog open={confirmDialog} setDialog={setConfirmDialog} onClickYes={purchase} loading={loading} error={purchaseError} />

        </>
    );
}


function ConfirmDialog({ open, setDialog, onClickYes, loading, error }: any) {
    return (<Dialog open={open ?? false} onClose={() => {
        if (!loading && !error) {
            if (setDialog) {
                setDialog(false);
            }
        }
    }} className="relative z-[60]">
        <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-[60] w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center items-center sm:p-0">
                <DialogPanel
                    transition
                    className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all max-w-lg data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                        <div className="sm:flex sm:items-start">

                            <div className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-200 sm:mx-0 sm:h-10 sm:w-10 ${error && 'hidden'}`}>
                                <FaQuestion aria-hidden="true" className="h-6 w-6 text-blue-700" />
                            </div>

                            <div className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-200 sm:mx-0 sm:h-10 sm:w-10 ${!error && 'hidden'}`}>
                                <FaExclamation aria-hidden="true" className="h-6 w-6 text-red-700" />
                            </div>

                            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                <DialogTitle as="h3" className="text-base font-semibold leading-6 text-gray-900">{error ? 'Purchase Error' : 'Confirm Purchase'}</DialogTitle>
                                <div className="mt-2">
                                    <div className="text-sm text-gray-700"><div dangerouslySetInnerHTML={{ __html: error ? error : 'Please review the purchase and payment details. If everything looks correct, click Yes to complete your purchase. If you need to make any changes or cancel, click No.' }} /></div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="bg-gray-50 px-4 py-3 flex flex-row justify-center sm:justify-end gap-3">

                        <button
                            type="button"
                            data-autofocus
                            disabled={loading}
                            onClick={loading ? undefined : () => {
                                if (setDialog) {
                                    setDialog(false);
                                }
                            }}
                            className={`inline-flex min-h-[38px] w-[86px] items-center justify-center rounded-xl bg-white px-3 text-sm font-semibold text-slate-700 ring-1 ring-inset ring-slate-200 transition hover:bg-slate-50 ${!error && 'hidden'}`}
                        >
                            OK
                        </button>

                        <div className={`flex flex-row gap-3 ${error && 'hidden'}`}>
                            <button
                                className='inline-flex min-h-[38px] w-[86px] items-center justify-center gap-1.5 rounded-xl bg-gradient-to-b from-blue-500 to-blue-600 px-3 text-sm font-bold text-white shadow-lg shadow-blue-600/25 transition hover:from-blue-600 hover:to-blue-700 disabled:from-slate-300 disabled:to-slate-300'
                                disabled={loading}
                                onClick={onClickYes}>
                                {loading && <Spinner className='inline mr-2' />}Yes
                            </button>

                            <button
                                type="button"
                                data-autofocus
                                disabled={loading}
                                onClick={loading ? undefined : () => {
                                    if (setDialog) {
                                        setDialog(false);
                                    }
                                }}
                                className="inline-flex min-h-[38px] w-[86px] items-center justify-center rounded-xl bg-white px-3 text-sm font-semibold text-slate-700 ring-1 ring-inset ring-slate-200 transition hover:bg-slate-50"
                            >
                                No
                            </button>
                        </div>

                    </div>
                </DialogPanel>
            </div>
        </div>
    </Dialog>)
}

function scrollToSection(id: string) {
    const element = document.getElementById(id);
    if (element) {
        const y = element.getBoundingClientRect().top + (window.scrollY - 50);
        window.scrollTo({ top: y, behavior: 'smooth' });
    }
}